import { render, staticRenderFns } from "./CookingTotal.vue?vue&type=template&id=4646b9a2&"
import script from "./CookingTotal.vue?vue&type=script&lang=js&"
export * from "./CookingTotal.vue?vue&type=script&lang=js&"
import style0 from "./CookingTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports